import style from "./PriceBlock.module.scss";

const PriceBlock = ({
  cost,
}: {
  cost: { amount: number; currencyCode: string | number };
}) => {
  return (
    <div className={style.priceBlock}>
      <h4>
        {cost.currencyCode} {cost.amount} <span>total</span>
      </h4>

      <hr />

      <div className={style.priceBlock__info}>
        <h5>Additional benefits</h5>
        <ul>
          <li>Online check-in</li>
        </ul>
      </div>
    </div>
  );
};
export default PriceBlock;
